<template lang="pug">
  //- CONTENT TEMPLATE
  conteudo#conteudo(v-if='!loading')
    header(slot="header")
      titulo.-withbar(name='titulo') {{ pagina.titulo }}
    .texto(slot="content" v-html='pagina.corpo')
    footer(slot="footer")
      br
      back-and-share
  //- LOADING TEMPLATE
  conteudo(v-else)
    span.sr-only Carregando...
    .loading-container.conteudo-loading(slot="loading")
      .header
        .subtitulo.animated(style="height:28px")
      .texto
        .slot
          .paragraph.animated.full
          .paragraph.animated.full
          .paragraph.animated.three-quarter
          .paragraph.animated.middle
        .slot
          .paragraph.animated.full
          .paragraph.animated.full
          .paragraph.animated.three-quarter
          .paragraph.animated.middle
</template>

<script>
  import BackAndShare from 'COMPONENTS/BackAndShare'
  import Conteudo from 'COMPONENTS/Artigo'
  import Titulo from 'COMPONENTS/ContentTitle'
  import PaginaExtraService from '../../js/api/PaginaExtraService'

  import * as config from '../../js/config'

  export default {
    components: {
      BackAndShare,
      Conteudo,
      Titulo
    },

    data () {
      return {
        loading: true,
        pagina: {
          titulo: '',
          corpo: ''
        },
        slug: ''
      }
    },
    head: {
      title: function () {
        return {
          inner: config.SITE_TITLE + ' - ' + this.pagina.titulo
        }
      },
      meta: function () {
        return [
          { name: 'description', content: config.SITE_DESC + ' - página de ' + this.pagina.titulo, id: 'description' },
          { p: 'og:title', c: config.SITE_TITLE + ' - ' + this.pagina.titulo }
        ]
      }
    },
    methods: {
      loadPage (slug, unidade = 'proad') {
        this.loading = true
        PaginaExtraService.getPagina(slug, unidade)
        .then(paginaDados => {
          this.pagina.titulo = paginaDados.title.rendered
          this.pagina.corpo = paginaDados.acf.descricao
          this.loading = false
        })
      },
      getAsyncData: function () {
        var self = this
        window.setTimeout(function () {
          self.pagina.titulo = self.pagina.titulo
          self.$emit('updateHead')
        }, 3000)
      }
    },

    watch: {
      slug: function () {
        this.loadPage(this.slug)
      }
    },

    mounted () {
      this.slug = (this.$route.params.slug) ? this.$route.params.slug : ''

      if (this.slug !== '') {
        this.loadPage(this.slug)
      }
      this.getAsyncData()
    },

    beforeUpdate () {
      this.slug = (this.$route.params.slug) ? this.$route.params.slug : ''
    }
  }
</script>



// WEBPACK FOOTER //
// Extra.vue?16a20597